module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper border-bottom white-bg page-heading"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), (_vm.user.isClientOrCarrier) ? _c('div', {
    staticClass: "col-sm-12 col-md-5 col-lg-2"
  }, [(_vm.user.isNotActivated) ? _c('p', {
    staticClass: "job-status-header text-warning"
  }, [_vm._v("Inactive")]) : (_vm.user.isArchived) ? _c('p', {
    staticClass: "job-status-header text-warning"
  }, [_vm._v("Archived")]) : (_vm.user.isDisabled) ? _c('p', {
    staticClass: "job-status-header text-danger"
  }, [_vm._v("Disabled")]) : (_vm.user.isUnverified) ? _c('p', {
    staticClass: "job-status-header text-info"
  }, [_vm._v("Unverified")]) : (_vm.user.isEnabled) ? _c('p', {
    staticClass: "job-status-header text-success"
  }, [_vm._v("Enabled")]) : _vm._e()]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-10 col-lg-9"
  }, [_c('h1', [_c('i', {
    staticClass: "far fa-user-circle m-r-sm"
  }), _vm._v(" Account Details")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-331decaa"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/SettingsHeading.vue
// module id = 968
// module chunks = 0